var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.07741 11.4298L10.4845 9.62545L12.7772 6.68531C13.2558 6.06248 12.9129 5 12.2273 5L3.77051 5C3.08483 5 2.74199 6.06248 3.22768 6.68531L6.92751 11.4298C7.5132 12.1901 8.48458 12.1901 9.07741 11.4298Z",
    fill: "#9094A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleArrow);
export default __webpack_public_path__ + "static/media/triangleArrow.e55beb7e4dca0fa29a0a1ab297d68460.svg";
export { ForwardRef as ReactComponent };